import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Row, Col, Image } from 'react-bootstrap';
import Treeview from 'components/common/Treeview';
import exampleWorkflow from '../../../assets/img/generic/example-workflow.png';

const treeviewItems = [
  {
    name: 'Introduction',
    id: '1',
    icon: 'book'
  },

  {
    name: 'Create a listing',
    id: '2',
    children: [
      {
        name: 'Select land parcels',
        id: '2.1',
        icon: 'book'
      },
      {
        name: 'Input listing details',
        id: '2.2',
        icon: 'book'
      },
      {
        name: 'Setting selling options and pricing',
        id: '2.3',
        icon: 'book'
      }
    ]
  },
  {
    name: 'Search for listings',
    id: '3',
    children: [
      {
        name: 'Set your default location',
        id: '3.1',
        icon: 'book'
      }
    ]
  },
  {
    name: 'Land development',
    id: '4',
    children: [
      {
        name: 'First step',
        id: '4.1',
        icon: 'book'
      }
    ]
  }
];
const GettingStartedModal = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Getting started
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={3}>
            <Treeview
              data={treeviewItems}
              expanded={['1', '2', '3', '7', '18']}
            />
          </Col>
          <Col md={8}>
            <Image src={exampleWorkflow} fluid />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

GettingStartedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default GettingStartedModal;
